import { makeStyles } from "@material-ui/core";
import { shadow } from "../../../assets/const";
import { color } from "../../../assets/const/color";

export const useStyles = makeStyles(() => ({
  addStaff_main: {
    fontFamily: "inter !important",
    "& p": {
      fontFamily: "inter !important",
    },
    "& .MuiAccordionSummary-content": {
      alignItems: "center",
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
      paddingRight: "10px",
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      paddingLeft: "0px",
      paddingRight: "0px",
    },
    "& .MuiAccordionDetails-root": {
      padding: "16px 40px 16px",
    },
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
      // minWidth: "200px",
    },
    "& .MuiFormControlLabel-label": {
      fontFamily: "inter !important",
    },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.lightGreen} !important`,
    },
    "& .MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "16.5px 35px",
      // minWidth: "240px !important",
      // width: "150px"
    },
    // "&.css-11jhixt-MuiStack-root img": {
    //   borderRadius: "50px",
    // },

    "& .react-tel-input .form-control" :{
      width: '222px',
      height: '57px',
      borderRadius: '40px'
    },
    "& .react-tel-input .flag-dropdown ":{
      borderRadius: "30px 0 0 30px !important",
    },
    "& .react-tel-input .flag-dropdown.open":{
      borderRadius: "30px 0 0 30px !important",
    }
  },
  profile_card: {
    width: "100%",
    // height: "50vh",
    background: "white",
    filter: shadow,
    borderRadius: "23px",
    alignItems: "center",
    padding: "24px 0px",
  },
  heading: {
    width: "100%",
    color: "#00473E",
    fontWeight: "700",
    fontSize: "18px",
  },
  secondaryHeading: {
    width: "100%",
    color: "#00473E",
    fontWeight: "700",
    fontSize: "18px",
  },
  add_btn: {
    width: "100%",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },
  upload_photo: {
    padding: "15px 25px",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
    borderRadius: "50px !important",
    margin: "0px !important",
    borderColor: `${color.lightGreen} !important`,
  },
  label: {
    color: "#374151",
    fontFamily: "inter !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
  },
  error: {
    color: "red",
    fontSize: "12px",
  },
  inputError: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgb(255 0 0 / 48%)",
    },
    "& .MuiOutlinedInput-root.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
    "& .MuiOutlinedInput-root:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
  },
}));
